import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CheckmarkCircled from '../../legacyCore/icons/CheckmarkCircled';

import style from './CheckmarkList.scss';

const CheckmarkList = ({ children, className, ...props }) => (
  <ul className={classNames('list-reset', className)} {...props}>
    {React.Children.map(children, (child) =>
      React.cloneElement(
        child,
        { className: classNames(style['checkmark-list__item'], child.props.className) },
        <React.Fragment>
          <CheckmarkCircled className={style['checkmark-list__icon']} />
          <div className={style['checkmark-list__content']}>{child.props.children}</div>
        </React.Fragment>
      )
    )}
  </ul>
);

CheckmarkList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default CheckmarkList;
